import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    padding: 110px;
  `}
`;


export const Title = styled.h2`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 24px 0px;
    text-align: center;
  `}
`;

export const ProgressBarWrapper = styled.div`
  display: block;
  max-width: 345px;
  width: 100%;
`;
